import React from 'react'

import { useTheme } from '@emotion/react'

import { useHelpTextId } from '../../../hooks/useHelpTextId'
import ArcadeHelpText, { ArcadeHelpTextComponentProps, extractHelpTextProps } from '../Input/ArcadeHelpText'
import { HelpTextProps, InputCard } from '../InputCard/InputCard'
import RadioCell, { RadioCellProps } from '../RadioCell/RadioCell'

export interface RadioInputCardProps extends RadioCellProps, ArcadeHelpTextComponentProps {
  cellProps?: Omit<RadioCellProps['cellProps'], HelpTextProps>
}

export default React.forwardRef<HTMLDivElement, RadioInputCardProps>((props, ref) => {
  const { spacing } = useTheme()
  const { disabled, ...restProps } = props
  const helpTextProps = extractHelpTextProps(props)
  const helpTextId = useHelpTextId(helpTextProps)

  return (
    <>
      <InputCard>
        <RadioCell
          headerSpacing={spacing.xxs}
          ref={ref}
          disabled={disabled}
          cellProps={{ helpTextId }}
          {...restProps}
        />
      </InputCard>
      <ArcadeHelpText helpTextId={helpTextId} {...helpTextProps} />
    </>
  )
})
